import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CacheService } from '../services/cashe-service';

@Directive({
  selector: '[appCheckIfGovAgencyUserDirective]'
})
export class CheckIfGovAgencyUserDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef  ) { }

  @Input() set appCheckIfGovAgencyUserDirective(anyVal: string[]) { 
    var AgnecyId= CacheService.getAgnecyId();
    if(AgnecyId!=null && AgnecyId!=undefined && AgnecyId!=""){
        this.viewContainer.createEmbeddedView(this.templateRef);
    }else{
        this.viewContainer.clear();
    }
  }
}
